import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import _ from 'lodash';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BrainParametersService {
  constructor(private readonly http: HttpClient) {}

  getBrainParametersGroups(): Observable<Group[]> {
    return this.http.get<Group[]>('v2/brain-parameters/groups');
  }

  getBrainParameters(visibility: Visibility): Observable<BrainParameter[]> {
    return this.http.get<BrainParameter[]>(`v2/brain-parameters/${visibility}`);
  }

  getBrainParametersAndGroups(visibility: Visibility): Observable<ParamsGroup[]> {
    return forkJoin({
      groups: this.getBrainParametersGroups(),
      parameters: this.getBrainParameters(visibility),
    }).pipe(
      map(({ groups, parameters }) => {
        const paramsBySubGroupUid = _(parameters)
          .groupBy((g) => g.subGroupUid)
          .value();
        return groups.map((group) => ({
          ...group,
          subGroups: group.subGroups.map((subGroup) => ({
            ...subGroup,
            params: paramsBySubGroupUid[subGroup.uid],
          })),
        }));
      }),
    );
  }
}

export interface ParamsGroup {
  id: number;
  label: string;
  subGroups: ParamsSubGroup[];
}

export type ParamsSubGroup = SubGroup & {
  params: BrainParameter[];
};

export type Group = {
  id: number;
  uid: string;
  label: string;
  subGroups: SubGroup[];
};

export type SubGroup = {
  id: number;
  uid: string;
  label: string;
  description: string;
  aggravatingFactor: boolean;
};

export type BrainTunableType = 'input' | 'toggleButton';

export type BrainParameter = {
  uid: string;
  visibility: Visibility;
  type: BrainTunableType;
  min: number;
  max: number;
  recommendedValue: number;
  label: string;
  subGroupUid: string;
};
export type Visibility = 'advanced' | 'expert' | 'adminCluster' | 'admin';
